function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as quizzActions from './quizzActions';

import Question from './Question/Question';
import Modal from './Modal/Modal';
import Aux from './hoc/_Aux';

export var Quizz = function (_Component) {
    _inherits(Quizz, _Component);

    function Quizz() {
        var _temp, _this, _ret;

        _classCallCheck(this, Quizz);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            isLoaded: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Quizz.prototype.componentDidMount = function componentDidMount() {
        var dispatch = this.props.dispatch;

        var currentQuizzId = typeof this.props.blockQuizzId !== 'undefined' ? this.props.blockQuizzId : '';

        dispatch(quizzActions.getQuizzData(currentQuizzId));
    };

    Quizz.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // EBE, here we make sure that both actions "getQuizzData" and "getQuestionData" are called before displaying the question component and this is done through the following state logic
        var currentQuizzId = typeof props.blockQuizzId !== 'undefined' ? props.blockQuizzId : '';
        if (!state.isLoaded && Object.keys(props.quizz.articleQuizzes).length > 0 && props.quizz.articleQuizzes.hasOwnProperty(currentQuizzId) && props.quizz.articleQuizzes[currentQuizzId].hasOwnProperty('quizzAnswers') && props.quizz.articleQuizzes[currentQuizzId].quizzAnswers.length > 0) {
            return { isLoaded: true };
        }

        return null;
    };

    Quizz.prototype.componentWillUnmount = function componentWillUnmount() {
        var dispatch = this.props.dispatch;

        var currentQuizzId = typeof this.props.blockQuizzId !== 'undefined' ? this.props.blockQuizzId : '';
        dispatch(quizzActions.resetQuizz(currentQuizzId));
    };

    Quizz.prototype.render = function render() {
        var quizz = this.props.quizz;


        var quizzElement = null;
        var modalOutput = null;
        var currentQuizzId = typeof this.props.blockQuizzId !== 'undefined' ? this.props.blockQuizzId : '';

        if (quizz.hasError) {
            //Error TODO
            quizzElement = React.createElement(
                'div',
                null,
                'Desol\xE9 je rencontre une erreur'
            );
        } else if (this.state.isLoaded) {
            // we make sure to load question after getQuizzData call is done (on ComponentDidMount)
            quizzElement = React.createElement(Question, { relatedToQuizzId: currentQuizzId });
        }

        if (currentQuizzId !== '' && this.state.isLoaded) {
            modalOutput = React.createElement(Modal, { isUnlockingArticle: !this.props.isLastBlock, relatedToQuizzId: currentQuizzId });
        }

        return React.createElement(
            Aux,
            null,
            modalOutput,
            quizzElement
        );
    };

    return Quizz;
}(Component);;

var mapStateToProps = function mapStateToProps(state) {
    return {
        quizz: state.quizz
    };
};

export default connect(mapStateToProps)(Quizz);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/Quizz.js
// module id = 105
// module chunks = 0